module.exports = __webpack_public_path__ + "img/mombasa1.8ca77ca8.jpg";